/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/hooks/useResponsiveToolDisplay.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useCustomMediaQuery } from 'academy-common-lib/utils/Styling';

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/hooks/useResponsiveToolDisplay.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useResponsiveToolDisplay = ({
  collectionType
}) => {
  const hasSpaceForThree = useCustomMediaQuery('(min-width: 1500px)');
  const hasSpaceForTwo = useCustomMediaQuery('(min-width: 1400px)');
  const hasSpaceForOneShort = useCustomMediaQuery('(min-width: 1300px)');
  const hasSpaceForOneLesson = useCustomMediaQuery('(min-width: 760px)');
  if (!collectionType || hasSpaceForThree) {
    return 3;
  }
  if (hasSpaceForTwo) {
    return 2;
  }
  if (collectionType === 'shortPlaylist' && hasSpaceForOneShort || collectionType === 'lesson' && hasSpaceForOneLesson) {
    return 1;
  }
  return 0;
};